import React, { useState, useMemo } from "react";
import { useVesselContext } from "../../../contexts/VesselContext";
import { useMapDisplayContext } from "../../../contexts/MapDisplayContext";
import styles from "./SeacrhVessel.module.css";

const SearchVessel: React.FC = () => {
  const { vessels } = useVesselContext();
  const { action} = useMapDisplayContext();
  const [searchText, setSearchText] = useState("");

  const vesselsList = useMemo(() => Object.values(vessels), [vessels]);
  const filteredVessels = useMemo(() => {
    if (!searchText) return [];
    return vesselsList.filter(
      vessel =>
        vessel.vesselName?.toLowerCase().includes(searchText.toLowerCase()) ||
        vessel.unitId?.toLowerCase().includes(searchText.toLowerCase())
    );
  }, [searchText, vesselsList]);

  const handleItemClick = (vessel: any) => {
    action.clickVesselMarker(vessel.unitId);
  };

  return (
    <>
      <div className="input-group">
        <input
          className="search-input form-control"
          type="text"
          placeholder="Tên tàu thuyền hoặc mã thiết bị"
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
        />
      </div>
      <div className={styles["search-results-list"] + " styled-scrollbar"}>
        {filteredVessels.map(vessel => (
          <div
            className={styles["search-item"]}
            key={vessel.unitId}
            onClick={() => handleItemClick(vessel)}
          >
            <div className={styles["search-item-info"]}>
              <div className={styles["name"]}>{vessel.vesselName}</div>
              <div className={styles["unitid"]}>{vessel.unitId}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default SearchVessel;
